import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';
import { User } from '../../utils/types';

const initialState: User | undefined = {
  userName: '',
  role: '',
  userId: 0,
  user_name: 'dummy',
};

export const authUserSlice = createSlice({
  name: 'authUserSlice',
  initialState,
  reducers: {
    updateAuthUser: (
      _state,
      action: PayloadAction<User>
    ) => ({ ...action.payload }),
    resetAuthUser: () => ({
      ...initialState,
    }),
  },
});

export const { updateAuthUser, resetAuthUser } =
  authUserSlice.actions;

export default authUserSlice.reducer;
